import { useState, useEffect } from 'react';
import { useCopy } from '../../i18n';
import { initializeGA4 } from '../../services/analyticsService';
import { Button } from '../ui/button';

const CONSENT_KEY = 'meugantt_cookie_consent';

const CookieConsent = () => {
  const t = useCopy().common.cookies;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    initializeGA4();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-[var(--color-gray-900)] text-white py-4 px-6 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
      <div className="max-w-[1200px] mx-auto flex items-center justify-between gap-6 max-sm:flex-col max-sm:text-center max-sm:gap-4">
        <p className="m-0 text-sm leading-relaxed text-[#ccc] [&_a]:text-[var(--color-primary)] [&_a]:underline [&_a:hover]:text-[var(--color-primary-light)]">
          {t.message}{' '}
          <a href="/privacidade" target="_blank" rel="noopener noreferrer">
            {t.privacyLink}
          </a>.
        </p>
        <div className="flex gap-3 shrink-0 max-sm:w-full max-sm:justify-center">
          <Button
            variant="outline"
            size="lg"
            className="border-[#555] text-[#ccc] hover:border-[#888] hover:text-white hover:bg-transparent"
            onClick={handleReject}
          >
            {t.reject}
          </Button>
          <Button
            variant="primary"
            size="lg"
            onClick={handleAccept}
          >
            {t.accept}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
